module.exports = __webpack_public_path__ + "media/images/athletes/3556-132968eddc50f77418b136ef272e4ecc.png";